import React from 'react';
import { CalendarDays } from 'lucide-react';

interface SchedulingStepEmptyStateProps {
  title?: string;
  description?: string;
}

export const SchedulingStepEmptyState: React.FC<
  SchedulingStepEmptyStateProps
> = ({
  title = 'Select a clinic to schedule',
  description = 'Choose a clinic on the Extraction tab. Scheduling will open in the correct EMR for that clinic.',
}) => {
  return (
    <div className='flex flex-col items-center h-full py-12 px-4 text-center'>
      <div className='bg-gray-50 p-4 rounded-full mb-4'>
        <CalendarDays className='h-8 w-8 text-gray-600' />
      </div>
      <h3 className='text-lg font-medium text-gray-900'>{title}</h3>
      <p className='text-sm text-gray-700 mt-1 max-w-sm'>{description}</p>
    </div>
  );
};
